var exports = {
  "iU": "Message.module__message___SHo5dn",
  "Ph": "Message.module__messagePreviewSpacing___SHo5dn",
  "IL": "Message.module__messagePreview___SHo5dn",
  "Xo": "Message.module__messageHovered___SHo5dn",
  "uK": "Message.module__focusRingAnchor___SHo5dn",
  "J8": "Message.module__messageCompact___SHo5dn",
  "L8": "Message.module__messageMentioned___SHo5dn",
  "m6": "Message.module__messageReplying___SHo5dn",
  "O6": "Message.module__messageHighlight___SHo5dn",
  "lY": "Message.module__contextMenuActive___SHo5dn",
  "Bc": "Message.module__mobileLayout___SHo5dn",
  "p2": "Message.module__messageLongPress___SHo5dn",
  "Uw": "Message.module__messageGrouped___SHo5dn",
  "kT": "Message.module__messageEditing___SHo5dn",
  "E4": "Message.module__messageSent___SHo5dn",
  "mr": "Message.module__messageSending___SHo5dn",
  "b$": "Message.module__messageFailed___SHo5dn",
  "RZ": "Message.module__failedFooter___SHo5dn",
  "Iu": "Message.module__failedFooterMessage___SHo5dn",
  "bg": "Message.module__failedFooterLabel___SHo5dn",
  "OZ": "Message.module__failedFooterIcon___SHo5dn",
  "dv": "Message.module__failedRetryIcon___SHo5dn",
  "QW": "Message.module__failedRetryButton___SHo5dn",
  "q5": "Message.module__messageGutterLeft___SHo5dn",
  "ZN": "Message.module__messageGutterRight___SHo5dn",
  "$7": "Message.module__messageAvatar___SHo5dn",
  "CW": "Message.module__messageNoText___SHo5dn",
  "U7": "Message.module__messageContent___SHo5dn",
  "rO": "Message.module__messageAuthorInfo___SHo5dn",
  "xW": "Message.module__jumpHeading___SHo5dn",
  "RO": "Message.module__jumpHeadingButton___SHo5dn",
  "dw": "Message.module__messageAuthorRow___SHo5dn",
  "um": "Message.module__messageUsername___SHo5dn",
  "Lo": "Message.module__messageText___SHo5dn",
  "AY": "Message.module__messageAuthorPart___SHo5dn",
  "oL": "Message.module__messageTimestamp___SHo5dn",
  "L5": "Message.module__messageTimestampCompact___SHo5dn",
  "tQ": "Message.module__compactAuthorPrefix___SHo5dn",
  "U6": "Message.module__copyOnly___SHo5dn",
  "Mz": "Message.module__compactInlineContent___SHo5dn",
  "aM": "Message.module__systemMessageContent___SHo5dn",
  "vp": "Message.module__contextMenuUnderline___SHo5dn",
  "aE": "Message.module__messageTimeoutIndicator___SHo5dn",
  "t4": "Message.module__textSeparator___SHo5dn",
  "BK": "Message.module__authorDashSeparator___SHo5dn",
  "KL": "Message.module__messageTimestampHover___SHo5dn",
  "jh": "Message.module__messageTimestampCompactHover___SHo5dn",
  "iZ": "Message.module__messageAvatarCompact___SHo5dn",
  "kq": "Message.module__compactContentWrapper___SHo5dn",
  "xv": "Message.module__hoverAction___SHo5dn",
  "kL": "Message.module__container___SHo5dn",
  "tI": "Message.module__repliedMessage___SHo5dn",
  "_T": "Message.module__repliedMessageCompact___SHo5dn",
  "$y": "Message.module__repliedTextPreview___SHo5dn",
  "NL": "Message.module__repliedAvatar___SHo5dn",
  "a3": "Message.module__repliedIconContainer___SHo5dn",
  "Pq": "Message.module__repliedIcon___SHo5dn",
  "EK": "Message.module__repliedUsername___SHo5dn",
  "IQ": "Message.module__repliedItalic___SHo5dn",
  "Mx": "Message.module__unstyled___SHo5dn",
  "Io": "Message.module__repliedTextContent___SHo5dn",
  "c": "Message.module__systemMessageFollowsSystem___SHo5dn",
  "Hj": "Message.module__systemMessageIconWrapper___SHo5dn",
  "Po": "Message.module__systemMessageIconCompact___SHo5dn",
  "jJ": "Message.module__systemMessageTimestamp___SHo5dn",
  "rc": "Message.module__systemMessageContentWrapper___SHo5dn",
  "V_": "Message.module__systemMessageCompactContent___SHo5dn",
  "Gq": "Message.module__systemMessageIconSvg___SHo5dn",
  "hr": "Message.module__systemMessageLink___SHo5dn",
  "x": "Message.module__userTagOffset___SHo5dn",
  "ll": "Message.module__userTagCompact___SHo5dn",
  "O4": "Message.module__editedTimestamp___SHo5dn",
  "k8": "Message.module__editedLabel___SHo5dn",
  "zX": "Message.module__typingContainer___SHo5dn",
  "Y9": "Message.module__typingCluster___SHo5dn",
  "RL": "Message.module__typingIndicator___SHo5dn",
  "Kl": "Message.module__typingAvatarContainer___SHo5dn",
  "tY": "Message.module__typingText___SHo5dn",
  "AZ": "Message.module__typingClusterComposerStatus___SHo5dn",
  "am": "Message.module__compactContentNoPrefix___SHo5dn",
  "Ys": "Message.module__compactBody___SHo5dn",
  "Ac": "Message.module__unknownMessageCompactContent___SHo5dn",
  "qU": "Message.module__unknownMessageWarning___SHo5dn",
  "NG": "Message.module__keyboardFocused___SHo5dn",
  "an": "Message.module__messageClientSystem___SHo5dn",
  "og": "Message.module__systemMessageContainer___SHo5dn",
  "Is": "Message.module__systemMessageIcon___SHo5dn",
  "ry": "Message.module__mediaFocusRing___SHo5dn",
  "xS": "Message.module__systemMessageDismissButton___SHo5dn",
  "Eu": "Message.module__silentMessageIcon___SHo5dn",
};

module.exports = exports;
